import { useCallback } from 'react';
import { getPeopleSyncRun, listPeopleSyncRuns } from '../../../api/peopleSync';
import { SyncRunsGrid } from '../SyncJobs/components/SyncRunsGrid';

export function PeopleSyncLogsPage() {
  const loadPage = useCallback(
    (request: Parameters<typeof listPeopleSyncRuns>[0]) => listPeopleSyncRuns(request),
    []
  );

  return (
    <div className="ops-fill-page ops-fill-page--bare">
      <div className="ops-fill-page__grid-host">
        <SyncRunsGrid
          loadPage={loadPage}
          loadDetails={getPeopleSyncRun}
          showJobName
          stateStorageKey="webopsui:people-sync-runs-grid"
        />
      </div>
    </div>
  );
}
